import React from 'react';

import { useListAccountGroupProfilesWithAumIncluded } from 'views/portfolio/account-aum-queries';
import { useAggregatedTransactionReport } from 'views/portfolio/reporting-queries';

import { useReportingScope } from '../reporting/useReportingScope';
import { NetInflowOutflow } from './components/NetInflowOutflow';
import { TransactionsHero } from './components/TransactionsHero';
import { TransactionsTable } from './components/TransactionsTable';
import { monthlyNetFlow } from './transactions';

// The Transactions section of the reporting overview: the net flow KPIs, the monthly cash flow
// chart and the most recent transactions. Reads its scope from the URL like the other sections.
export const TransactionsSection = () => {
    const { householdGUID, dateRange, selectedAccountGUIDs, includeClosed } = useReportingScope();
    const transactionsQuery = useAggregatedTransactionReport({
        householdGUID,
        ...dateRange,
        groupByGuids: selectedAccountGUIDs,
        includeClosed,
    });
    // Same query as ReportingHeader's account selector, so it is served from cache.
    const profilesQuery = useListAccountGroupProfilesWithAumIncluded(householdGUID);
    // Bucketed once and shared, so the hero totals are the chart's months added up.
    const flows = React.useMemo(() => monthlyNetFlow(transactionsQuery.data ?? []), [transactionsQuery.data]);

    return (
        <>
            <TransactionsHero flows={flows} isLoading={transactionsQuery.isPending} />
            <NetInflowOutflow flows={flows} isLoading={transactionsQuery.isPending} />
            {/* Waits for the account names too, so rows never flash "Unknown account". */}
            <TransactionsTable
                transactions={transactionsQuery.data}
                accounts={profilesQuery.data?.flatMap((profile) => profile.accounts) ?? []}
                isLoading={transactionsQuery.isPending || profilesQuery.isPending}
            />
        </>
    );
};
